// @ts-strict-ignore
import { KeyedResource } from './keyed.resource';

export class FormResource extends KeyedResource {
  private formNameImpl: string;
  private panelNameImpl: string;

  constructor(args: any) {
    super(args, args.formName);

    this.resourceType = 'form';

    if (this.uiResourceName) {
      const result = this.uiResourceName.split('.');
      this.formNameImpl = result[ 0 ];

      if (result.length > 1) {
        this.panelNameImpl = result[ 1 ];
      }
    }
  }

  public get formName() {
    return this.formNameImpl;
  }

  public get panelName() {
    return this.panelNameImpl;
  }
}
